<template>
  <div class="page-container">
    <el-card shadow="never">
      <!-- 状态Tab -->
      <div class="status-tabs">
        <el-tabs v-model="query.status" @tab-click="handleTabClick">
          <el-tab-pane label="全部" name="" />
          <el-tab-pane label="待审核" name="PENDING" />
          <el-tab-pane label="已通过" name="APPROVED" />
          <el-tab-pane label="已拒绝" name="REJECTED" />
        </el-tabs>
      </div>

      <div class="toolbar">
        <div class="toolbar-left">
          <el-input
            v-model="query.orderId"
            placeholder="订单ID"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            style="width: 180px; margin-right: 12px;"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button size="small" icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
        </div>
      </div>

      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%; margin-top: 16px;"
      >
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="aftersaleId" label="售后单号" width="160" show-overflow-tooltip />
        <el-table-column prop="orderId" label="订单ID" width="100" align="center" />
        <el-table-column prop="compensationType" label="赔付类型" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getCompensationTypeTag(scope.row.compensationType)" size="small">
              {{ getCompensationTypeText(scope.row.compensationType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="compensationAmount" label="赔付金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #F56C6C;">¥{{ scope.row.compensationAmount || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="penaltyAmount" label="违约金" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #E6A23C;">¥{{ scope.row.penaltyAmount || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="总金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: bold;">¥{{ scope.row.totalAmount || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="aftersaleStatus" label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.aftersaleStatus)" size="small">
              {{ getStatusText(scope.row.aftersaleStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="payStatus" label="支付状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getPayStatusType(scope.row.payStatus)" size="small">
              {{ getPayStatusText(scope.row.payStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="赔付原因" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="创建时间" width="160" />
        <el-table-column label="操作" width="200" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">
              详情
            </el-button>
            <el-button
              v-if="scope.row.aftersaleStatus === 'PENDING'"
              type="text"
              size="small"
              style="color: #67C23A;"
              @click="handleApprove(scope.row, true)"
            >
              通过
            </el-button>
            <el-button
              v-if="scope.row.aftersaleStatus === 'PENDING'"
              type="text"
              size="small"
              style="color: #F56C6C;"
              @click="handleApprove(scope.row, false)"
            >
              拒绝
            </el-button>
            <el-button
              v-if="scope.row.aftersaleStatus === 'APPROVED' && (scope.row.payStatus === 'UNPAID' || scope.row.payStatus === 'FAILED')"
              type="text"
              size="small"
              style="color: #E6A23C;"
              @click="handleDeduct(scope.row)"
            >
              {{ scope.row.payStatus === 'FAILED' ? '重试扣款' : '发起扣款' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="query.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog title="赔付详情" :visible.sync="detailDialogVisible" width="600px">
      <el-descriptions :column="2" border size="small" v-if="currentRecord">
        <el-descriptions-item label="售后单号">{{ currentRecord.aftersaleId }}</el-descriptions-item>
        <el-descriptions-item label="订单ID">{{ currentRecord.orderId }}</el-descriptions-item>
        <el-descriptions-item label="赔付类型">
          <el-tag :type="getCompensationTypeTag(currentRecord.compensationType)" size="small">
            {{ getCompensationTypeText(currentRecord.compensationType) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag :type="getStatusType(currentRecord.aftersaleStatus)" size="small">
            {{ getStatusText(currentRecord.aftersaleStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="赔付金额">
          <span style="color: #F56C6C;">¥{{ currentRecord.compensationAmount || '0.00' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="违约金">
          <span style="color: #E6A23C;">¥{{ currentRecord.penaltyAmount || '0.00' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="总金额">
          <span style="color: #409EFF; font-weight: bold;">¥{{ currentRecord.totalAmount || '0.00' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付状态">
          <el-tag :type="getPayStatusType(currentRecord.payStatus)" size="small">
            {{ getPayStatusText(currentRecord.payStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="赔付原因" :span="2">{{ currentRecord.reason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="详细描述" :span="2">{{ currentRecord.description || '-' }}</el-descriptions-item>
        <el-descriptions-item label="证据图片" :span="2" v-if="currentRecord.evidenceImages">
          <div class="evidence-images">
            <el-image
              v-for="(img, index) in parseEvidenceImages(currentRecord.evidenceImages)"
              :key="index"
              :src="img"
              :preview-src-list="parseEvidenceImages(currentRecord.evidenceImages)"
              fit="cover"
              style="width: 80px; height: 80px; margin-right: 8px;"
            />
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentRecord.createdAt }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ currentRecord.updatedAt }}</el-descriptions-item>
        <el-descriptions-item label="审核时间" v-if="currentRecord.reviewedAt">{{ currentRecord.reviewedAt }}</el-descriptions-item>
        <el-descriptions-item label="审核备注" v-if="currentRecord.reviewRemark">{{ currentRecord.reviewRemark }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog :title="approveForm.approved ? '通过赔付申请' : '拒绝赔付申请'" :visible.sync="approveDialogVisible" width="500px">
      <el-form :model="approveForm" label-width="100px">
        <el-form-item label="审核备注">
          <el-input
            type="textarea"
            v-model="approveForm.reviewRemark"
            :placeholder="approveForm.approved ? '请输入审核通过备注（可选）' : '请输入拒绝原因'"
            :rows="4"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取消</el-button>
        <el-button :type="approveForm.approved ? 'success' : 'danger'" :loading="approveLoading" @click="submitApprove">
          {{ approveForm.approved ? '确认通过' : '确认拒绝' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCompensationList, approveCompensation, deductCompensation } from '@/api/order'
import { getCompensationTypeText as _getCompensationTypeText, getCompensationTypeTag as _getCompensationTypeTag, getAftersaleStatusText, getAftersaleStatusType, getPayStatusForAftersaleText, getPayStatusForAftersaleType } from '@common/statusMap.js'

export default {
  name: 'CompensationList',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        orderId: '',
        status: '',
        page: 1,
        size: 10
      },
      detailDialogVisible: false,
      currentRecord: null,
      approveDialogVisible: false,
      approveForm: {
        id: null,
        approved: true,
        reviewRemark: ''
      },
      approveLoading: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.query.page,
          size: this.query.size
        }
        if (this.query.orderId) {
          params.orderId = this.query.orderId
        }
        if (this.query.status) {
          params.status = this.query.status
        }
        const res = await getCompensationList(params)
        if (res.data) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        }
      } catch (e) {
        this.$message.error(e.message || '加载数据失败')
      } finally {
        this.loading = false
      }
    },
    handleTabClick() {
      this.query.page = 1
      this.loadData()
    },
    handleSearch() {
      this.query.page = 1
      this.loadData()
    },
    handleReset() {
      this.query = {
        orderId: '',
        status: '',
        page: 1,
        size: 10
      }
      this.loadData()
    },
    handleSizeChange(val) {
      this.query.size = val
      this.query.page = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.loadData()
    },
    handleDetail(row) {
      this.currentRecord = row
      this.detailDialogVisible = true
    },
    handleApprove(row, approved) {
      this.approveForm = {
        id: row.id,
        approved: approved,
        reviewRemark: ''
      }
      this.approveDialogVisible = true
    },
    async submitApprove() {
      if (!this.approveForm.approved && !this.approveForm.reviewRemark) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      this.approveLoading = true
      try {
        await approveCompensation(this.approveForm.id, {
          approved: this.approveForm.approved,
          reviewRemark: this.approveForm.reviewRemark,
          reviewedBy: this.$store?.state?.user?.id || null
        })
        this.$message.success(this.approveForm.approved ? '审核通过' : '已拒绝')
        this.approveDialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '审核失败')
      } finally {
        this.approveLoading = false
      }
    },
    async handleDeduct(row) {
      try {
        await this.$confirm('确认发起扣款吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deductCompensation(row.id)
        this.$message.success('扣款发起成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '扣款失败')
        }
      }
    },
    getCompensationTypeText(type) {
      return _getCompensationTypeText(type)
    },
    getCompensationTypeTag(type) {
      return _getCompensationTypeTag(type)
    },
    getStatusText(status) {
      return getAftersaleStatusText(status)
    },
    getStatusType(status) {
      return getAftersaleStatusType(status)
    },
    getPayStatusText(status) {
      return getPayStatusForAftersaleText(status)
    },
    getPayStatusType(status) {
      return getPayStatusForAftersaleType(status)
    },
    parseEvidenceImages(images) {
      if (!images) return []
      try {
        const parsed = typeof images === 'string' ? JSON.parse(images) : images
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
}
.status-tabs {
  margin-bottom: 16px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.toolbar-left {
  display: flex;
  align-items: center;
}
.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}
.evidence-images {
  display: flex;
  flex-wrap: wrap;
}
</style>
